import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModalService } from '@features/modals/services/modal.service';
import { Validators } from '@angular/forms';
import { FormFieldComponent } from '@core/components/form-field/form-field.component';
import { AdminBotsService } from '../admin-bots.service';
import { AdminBotAdd } from '../admin-bot.interface';

@Component({
  selector: 'app-admin-bot-add-modal',
  imports: [FormFieldComponent, ReactiveFormsModule],
  templateUrl: './admin-bot-add-modal.component.html',
  styleUrl: './admin-bot-add-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class AdminBotAddModalComponent {
  private readonly toastrService = inject(ToastrService);
  private readonly modalService = inject(ModalService);
  public readonly adminBotsService = inject(AdminBotsService);

  public isSubmitting = signal(false);

  name = new FormControl<string>('', [Validators.required]);
  password = new FormControl<string>('', [Validators.required]);
  steamid = new FormControl<string>('', [Validators.required]);
  sharedSecret = new FormControl<string>('', [Validators.required]);
  identitySecret = new FormControl<string>('', [Validators.required]);
  apiKey = new FormControl<string>('', [Validators.required]);
  tradelink = new FormControl<string>('', [Validators.required]);

  botForm = new FormGroup({
    name: this.name,
    password: this.password,
    steamid: this.steamid,
    sharedSecret: this.sharedSecret,
    identitySecret: this.identitySecret,
    apiKey: this.apiKey,
    tradelink: this.tradelink,
  });

  async onSubmit() {
    this.botForm.markAllAsTouched();

    if (!this.botForm.valid) {
      this.toastrService.error('Form is not valid. Please check the inputs.');
      return;
    }

    const formValues = this.botForm.value;

    const bot: AdminBotAdd = {
      name: formValues.name!,
      password: formValues.password!,
      steamid: formValues.steamid!,
      shared_secret: formValues.sharedSecret!,
      identity_secret: formValues.identitySecret!,
      api_key: formValues.apiKey!,
      tradelink: formValues.tradelink!,
    };
    this.isSubmitting.set(true);

    try {
      const res = await this.adminBotsService.addBot(bot);
      console.log('🚀 ~ AdminBotAddModalComponent ~ onSubmit ~ res:', res);
      this.adminBotsService.botsResource.reload();
      this.toastrService.success('Bot has been added successfully');
      this.modalService.close();
    } catch (error) {
      console.log('🚀 ~ AdminBotAddModalComponent ~ onSubmit ~ error:', error);
      this.toastrService.error('Failed to add bot. Please try again.');
    } finally {
      this.isSubmitting.set(false);
    }
  }
}
